import React from "react";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import { Stack, Typography } from "@mui/material";
import { BaseRate } from "./BaseRate";
import TermLimits from "./TermLimits";
import RateMatrix from "./RateMatrix";

const RatesPage = () => {
  useCrumb("/rates/", {
    to: `/rates`,
    text: "Rates",
  });
  return (
    <Stack spacing={5} sx={{ px: 5, pb: 5 }}>
      <Typography variant="h5">Manage Rates</Typography>
      <BaseRate />
      <TermLimits />
      <RateMatrix />
    </Stack>
  );
};

export default RatesPage;
